// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100px);
  }
}

@keyframes slideUp {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes dropdown {
  0% {
    height: 0;
    opacity: 0;
    visibility: hidden;
  }
  100% { 
    height: 180px;
    opacity: 1;
    visibility: visible;
  }
}

@keyframes enlarge {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes updown {
  0% {
    bottom: -8px;
  }
  15% {
    bottom: -16px;
  }
  30% {
    bottom: -8px;
  }
  45% {
    bottom: -16px;
  }
  60% {
    bottom: -8px;
  }
}

@keyframes score {
  0% { width: 0; }
  80% { width: calc(var(--bar-width) + 10px); }
  95% { width: calc(var(--bar-width) - 2px); }
  100% { width: var(--bar-width); }
}

@keyframes perfectScore {
  0% { background-color: blue; }
  15% { background-color: orange; }
  30% { background-color: hotpink; }
  45% { background-color: yellow; }
  60% { background-color: purple; }
  75% { background-color: blueviolet; }
  90% { background-color: blue; }
  100% { background-color: green; }
}

@keyframes fitScore {
  0% { width: 0; }
  100% { width: var(--bar-width); }
}

.a-fade-in-up-down {
  animation: 
    750ms fadeIn,
    1s updown 1.5s;
}

.a-enlarge {
  animation: enlarge 1.5s;
}

.a-score {
  animation: score 2s;
}

.a-perfect-score {
  animation: 
    1s fitScore, 
    2s perfectScore 1.5s;
}

.a-quiz-dropdown {
  animation: dropdown 500ms linear forwards;
  height: 180px;
  padding: 16px;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,MAAM,oCAAoC,EAAE;EAC5C,MAAM,mCAAmC,EAAE;EAC3C,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE,KAAK,sBAAsB,EAAE;EAC7B,MAAM,wBAAwB,EAAE;EAChC,MAAM,yBAAyB,EAAE;EACjC,MAAM,wBAAwB,EAAE;EAChC,MAAM,wBAAwB,EAAE;EAChC,MAAM,4BAA4B,EAAE;EACpC,MAAM,sBAAsB,EAAE;EAC9B,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE;;kBAEgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;wBAEsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["@keyframes slideDown {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(100px);\n  }\n}\n\n@keyframes slideUp {\n  0% {\n    transform: translateY(100px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes dropdown {\n  0% {\n    height: 0;\n    opacity: 0;\n    visibility: hidden;\n  }\n  100% { \n    height: 180px;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@keyframes enlarge {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.05);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes updown {\n  0% {\n    bottom: -8px;\n  }\n  15% {\n    bottom: -16px;\n  }\n  30% {\n    bottom: -8px;\n  }\n  45% {\n    bottom: -16px;\n  }\n  60% {\n    bottom: -8px;\n  }\n}\n\n@keyframes score {\n  0% { width: 0; }\n  80% { width: calc(var(--bar-width) + 10px); }\n  95% { width: calc(var(--bar-width) - 2px); }\n  100% { width: var(--bar-width); }\n}\n\n@keyframes perfectScore {\n  0% { background-color: blue; }\n  15% { background-color: orange; }\n  30% { background-color: hotpink; }\n  45% { background-color: yellow; }\n  60% { background-color: purple; }\n  75% { background-color: blueviolet; }\n  90% { background-color: blue; }\n  100% { background-color: green; }\n}\n\n@keyframes fitScore {\n  0% { width: 0; }\n  100% { width: var(--bar-width); }\n}\n\n.a-fade-in-up-down {\n  animation: \n    750ms fadeIn,\n    1s updown 1.5s;\n}\n\n.a-enlarge {\n  animation: enlarge 1.5s;\n}\n\n.a-score {\n  animation: score 2s;\n}\n\n.a-perfect-score {\n  animation: \n    1s fitScore, \n    2s perfectScore 1.5s;\n}\n\n.a-quiz-dropdown {\n  animation: dropdown 500ms linear forwards;\n  height: 180px;\n  padding: 16px;\n  margin-top: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
